import type { Language } from '@backoffice-frontend/common'
import { DEFAULT_LANGUAGE } from '@backoffice-frontend/common'
import type { ServiceArea } from '@backoffice-frontend/graphql'

type ServiceAreaLike = Pick<ServiceArea, 'displayNames'> &
  Partial<Pick<ServiceArea, 'id' | 'defaultLanguage'>>

export const getServiceAreaDisplayName = (
  serviceArea: ServiceAreaLike,
  lang: Language,
): string => {
  const { id, displayNames, defaultLanguage } = serviceArea

  if (!displayNames) {
    return id ?? ''
  }

  return (
    displayNames[lang] ||
    (defaultLanguage !== undefined && defaultLanguage in displayNames
      ? displayNames[defaultLanguage as keyof typeof displayNames]
      : undefined) ||
    displayNames[DEFAULT_LANGUAGE] ||
    id ||
    ''
  )
}
